import React from 'react';
import { FiGithub, FiLinkedin, FiInstagram, FiTwitter } from 'react-icons/fi';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="footer-logo">◆ OnlinUp</span>
        
        <ul className="footer-links">
          <li><a href="#servicos">Serviços</a></li>
          {/* <li><a href="#portfolio">Portfolio</a></li> */}
          <li><a href="#precos">Preços</a></li>
          <li><a href="#contato">Contato</a></li>
        </ul>

       {/*  <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', marginBottom: '2rem' }}>
          <a href="#" style={{ color: '#64748b', fontSize: '1.5rem', transition: 'color 0.3s' }}>
            <FiGithub />
          </a>
          <a href="#" style={{ color: '#64748b', fontSize: '1.5rem', transition: 'color 0.3s' }}>
            <FiLinkedin />
          </a>
          <a href="#" style={{ color: '#64748b', fontSize: '1.5rem', transition: 'color 0.3s' }}>
            <FiInstagram />
          </a>
          <a href="#" style={{ color: '#64748b', fontSize: '1.5rem', transition: 'color 0.3s' }}>
            <FiTwitter />
          </a>
        </div>
 */}
        <div className="footer-bottom">
          <p>© {currentYear} OnlinUp. Todos os direitos reservados.</p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
            Desenvolvido com ❤️ por OnlinUp
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;